import { render, staticRenderFns } from "./Section.vue?vue&type=template&id=49b52cda&"
import script from "./Section.vue?vue&type=script&lang=ts&"
export * from "./Section.vue?vue&type=script&lang=ts&"
import style0 from "./Section.vue?vue&type=style&index=0&id=49b52cda&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports